import { useDispatch, useSelector } from 'react-redux'

import { refinementRemove } from '~/app/store/refinement'
import { useRedirectToL0 } from '~/app/features/Gallery/hooks/RedirectToL0/useRedirectToL0'
import { REFINEMENT_DIMENSION } from '~/shared/constants'
import { getIsL1orL2 } from 'app/store/config'
import { ThunkDispatch } from '~/app/store/interface'
import type { Refinements } from '~/app/store/refinement/interface'

type CurryClearAllFunc = (selected: Refinements) => (event: React.MouseEvent<HTMLButtonElement>) => void

export const useClearRefinements = (): { curryClearAll: CurryClearAllFunc } => {
  const dispatch = useDispatch<ThunkDispatch>()
  const isL1orL2 = useSelector(getIsL1orL2)
  const redirectToL0 = useRedirectToL0()

  const curryClearAll =
    (selected: Refinements) =>
    (event: React.MouseEvent<HTMLButtonElement>): void => {
      event.preventDefault()
      const selectedRefinements = { ...selected }

      if (isL1orL2) {
        for (const refinement in selectedRefinements) {
          if (Object.hasOwn(selectedRefinements, refinement) && selectedRefinements[refinement].dimension === REFINEMENT_DIMENSION.CATEGORY) {
            delete selectedRefinements[refinement]
          }
        }
      }

      const refinements = Object.values(selectedRefinements)

      if (redirectToL0([], refinements)) {
        return
      }

      dispatch(refinementRemove(refinements, true))
    }

  return { curryClearAll }
}
